import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardMedia,
  Box,  
} from '@mui/material';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import Footer from '../navbar/Footer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 

const bulletinsData = [
   {
    title: 'Bulletin du Commerce Exterieur de Marchandises  du troisième trimestre 2025',
    link: '/documents/Bulletins/BTCE_T3_2025.pdf',
    date: new Date('2025-02-06'),
    image: 'assets/Bulletins/bull_comm_ext_2024_3tri.PNG', 
    description: "La balance commerciale observe une détérioration d’environ 7 ,6%. En effet, le déficit s’établie à 729,0milliards de BIF contre 677,5milliards enregistrés au même trimestre d’un an auparavant. La balance commerciale hors exportations temporaires et réexportations s’évalue à 745,6milliards au troisième trimestre de 2025.",
  },
    {
    title: 'Bulletin du Commerce Exterieur de Marchandises  du deuxième trimestre 2025',
    link: '/documents/Bulletins/BULLETIN_COMMERCE_EXTERIEUR_DEUXIEME_TRIMESTRE_2025.pdf',
    date: new Date('2025-06-14'),
    image: 'assets/Bulletins/bull_comm_ext_2024_3tri.PNG', 
    description: "Malgré un déficit commercial qui persiste à 610,6 milliards de BIF, la balance commerciale affiche une nette amélioration de 11,5% sur un an, portée par la dynamique des exportations domestiques qui représentent désormais 21,4% du total des échanges.",
  },
    {
    title: 'Bulletin du Commerce Exterieur de Marchandises  du premier trimestre 2025',
    link: '/documents/Bulletins/Bulletin du commerce exterieur-T1-25.pdf',
    date: new Date('2025-06-14'),
    image: 'assets/Bulletins/bull_comm_ext_2024_3tri.PNG', 
    description: "L'amélioration de la balance commerciale à hauteur de 12,5% et gain de 18,2 points du taux de couverture.",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2024',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur-T3-24-valide-_1_-_1_.pdf',
    date: new Date('2024-11-01'),
    image: 'assets/Bulletins/bull_comm_ext_2024_3tri.PNG', 
    description: "La balance commerciale observe une amélioration d’environ 8%, Soit un déficit de 691,6 milliards de BIF contre 638,9 milliards enregistré au trimestre correspondant de 2023.",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du deuxième trimestre 2024',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur-T2-24.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2024_1tri.PNG', 
    date: new Date('2024-09-01'),
    description: "La balance commerciale observe une déterioration de 4,5 % en glissement annuel et 6,0% en glissement trimestriel, soit un déficit de 676,0milliards de BIF contre 646,7milliards et 638 milliards respectivement au deuxième trimestre de 2023 et premier trimestre 2024. ",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2024',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur-T1-24.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2024_1tri.PNG', 
    date: new Date('2024-05-01'),
    description: "La balance commerciale observe une détérioration de la balance commerciale à hauteur de 22,3% au premier trimestre de 2024 , soit déficit se chiffre à 638,0millards au premier trimestre de 2024 contre 521,6milliards du trimestre correspondant d’une année avant et de 632,1 du trimestre précédent. ",
  },
  {
    title: 'Rapport annuel de 2022 sur le Commerce Extérieur des Marchandises au Burundi',
    link: '/documents/Bulletins/Rapport-annuel-2022-sur-les-statistiques-du-commerce-exterieur.pdf',
    image: 'assets/Bulletins/rapport_comm_exter_annuel2022.PNG', 
    date: new Date('2023-09-01'),
    description: "La balance commerciale atteint 2141 milliards en 2022 contre 1702 milliards en 2021 avec l’évolution des échanges commerciaux se caractérise par une hausse d’année en année depuis 2018 qui passe de 1736,0 milliards en 2018 à 2987,1 milliards en 2022.",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du quatrième trimestre 2023',
    link: '/documents/Bulletins/3Bulletin-trimestriel-du-Commerce-Exterieur-T4-23-_1_.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2023_4tri.PNG', 
    date: new Date('2023-12-01'),
    description: "La balance commerciale se détériore en passant de 517,9 milliards de BIF en 2022, à 632,1milliards de BIF en 2022 ; soit une hausse en valeur absolue de 114,2 milliards de BIF et 22,0 en pourcentage.",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2023',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur-T1-2023.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2023_1tri.PNG', 
    date: new Date('2023-05-01'),
    description: "Le déficit commercial s’élève à 502,7 milliards de BIF contre 408,2 milliards de BIF d’une année avant, soit une détérioration de plus de 23,1%",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du quatrième trimestre 2022',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur_T4-22-VF.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2022_4tri.PNG', 
    date: new Date('2023-02-01'),
    description: " Le déficit commercial s’élève à 542,6 milliards de BIF contre 373,2 milliards de BIF d’une année avant, soit une détérioration de plus de 40%.",
  },
 
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2022',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur_T3-22.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2022_3tri.PNG', 
    date: new Date('2022-12-01'),
    description: "La situation résulte du fait que les importations sont de loin supérieures aux exportations, environ 90% du total des échanges. Au cours de la période sous revue, le déficit commercial s’élève 459,5 milliards de BIF contre 591,3 milliards de BIF d’une année avant, soit une détérioration de 11,9%.",
  },
  {
    title: 'Bulletin du Commerce Exterieur de Marchandises du deuxième trimestre 2022',
    link: '/documents/Bulletins/Bulletin-trimestriel-du-Commerce-Exterieur_T2-22-VF.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2022_2tri.PNG', 
    date: new Date('2022-08-17'),
    description: "Le déficit de la balance commerciale s’élève 364,9 milliards de BIF contre 459,2 milliards de BIF au même trimestre de 2021, soit une légère amélioration de 21,7%.",
},
{
    title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2022',
    link: '/documents/Bulletins/Bulletin-du-commerce-exterieur_1er-trimestre-2022-_1_.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2022_1tri.PNG', 
    date: new Date('2022-05-30'),
    description: "Le déficit de la balance commerciale s’élève 408,2 milliards de BIF contre 459,2 milliards de BIF au même trimestre de 2021, soit une détérioration de 3,4%.",
},
{
    title: 'Bulletin du Commerce Exterieur de Marchandises du quatrième trimestre 2021',
    link: '/documents/Bulletins/Bulletin-CE-_4eme-trimestre-2021.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2021_4tri.PNG', 
    date: new Date('2021-12-30'),
    description: "Le déficit de la balance commerciale s’élève 444,7 milliards de BIF contre 337,9 milliards de BIF au même trimestre de 2020, soit une détérioration de 16,8%.",
},
{
    title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2021',
    link: '/documents/Bulletins/Bulletin-du-commerce-exterieur-_T3-2021_.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2021_3tri.PNG', 
    date: new Date('2021-09-29'),
    description: "Le déficit de la balance commerciale du trimestre sous analyse, s’élève à 493,2 milliards de BIF contre 325,5 milliards de BIF au même trimestre d’un an avant, soit une détérioration de plus de 50%.",
},
{
    title: 'Bulletin du Commerce Exterieur de Marchandises du deuxième trimestre 2021',
    link: '/documents/Bulletins/Bulletin-du-commerce-exterieur_2eme-trimestre-2021_VF.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2021_2tri.PNG', 
    date: new Date('2021-08-30'),
    description: "Le déficit de la balance commerciale pour le deuxième trimestre 2021 s'établit à 459,2 milliards BIF, contre 337,9 milliards BIF pour la même période l'année précédente, représentant une détérioration de 19,0 %.",
},
{
    title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2021',
    link: '/documents/Bulletins/Bulletin-du-commerce-exterieur_1er-trimestre-2021.pdf',
    image: 'assets/Bulletins/bull_comm_ext_2021_1tri.PNG', 
    date: new Date('2021-05-26'),
    description: "Le déficit de la balance commerciale du trimestre sous analyse, s’élève à 395,0 milliards de BIF contre 382,0 milliards de BIF au même trimestre de 2020, soit une détérioration de 3 ,4%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du quatrième trimestre 2020',
  link: '/documents/Bulletins/Bulletin-du-commerce-exterieur_4eme-trimestre-2020.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2020_4tri.PNG', 
  date: new Date('2020-12-09'),
  description: "Le déficit de la balance commerciale s’élève 337,9 milliards de BIF contre 369,5 milliards de BIF au même trimestre de 2019, soit un léger mieux de 8,5%. ",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2020',
  link: '/documents/Bulletins/Bulletin-du-commerce-extérieur_3ème-trimestre-2020_VF.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2020_3tri.PNG', 
  date: new Date('2020-19-10'),
  description: "Le déficit de la balance commerciale du trimestre sous analyse, s’élève à 325,1 milliards de BIF contre 337,4 milliards de BIF au même trimestre de 2019, soit une amélioration de 3,7%. ",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du deuxième trimestre 2020',
  link: '/documents/Bulletins/Bulletin-du-commerce-extérieur_2eme-trimestre-2020.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2020_2tri.PNG', 
  date: new Date('2020-08-28'),
  description: "Le déficit de la balance commerciale du trimestre sous analyse, s’élève à 385,9 milliards de BIF contre 269,4 milliards de BIF au même trimestre de 2019, soit une détérioration de 43,3%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2020',
  link: '/documents/Bulletins/Bulletin-du-commerce-extérieur_1er-trimestre-2020.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2020_1tri.PNG', 
  date: new Date('2020-05-29'),
  description: "Le déficit de la balance commerciale du trimestre sous analyse, s’élève à 385,7 milliards de BIF contre 328,3 milliards de BIF au même trimestre de 2019, soit une détérioration de 17,5%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du quatrième trimestre 2019',
  link: '/documents/Bulletins/Bulletin-du-commerce-exterieur_4eme-trimestre-2019_VF.doc.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2019_1tri.PNG', 
  date: new Date('2019-12-01'),
  description: "Le déficit de la balance commerciale s’élève à 337,4 milliards de BIF contre 301,8 milliards de BIF au même trimestre de 2018, soit une détérioration de 11,8%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2019',
  link: '/documents/Bulletins/Bulletin-du-commerce-exterieur_4eme-trimestre-2019_VF.doc (1).pdf',
  image: 'assets/Bulletins/bull_comm_ext_2019_3tri.PNG', 
  date: new Date('2019-11-29'),
  description: "Le déficit de la balance commerciale s’élève à 337,4 milliards de BIF contre 301,8 milliards de BIF au même trimestre de 2018, soit une détérioration de 11,8%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2019',
  link: '/documents/Bulletins/bulletin-du-commerce-extrieur_1er-trimestre-2019.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2019_1tri.PNG', 
  date: new Date('2019-05-29'),
  description: "Le déficit de la balance commerciale s’élève à 328,3 milliards de BIF contre 253,1 milliards de BIF au même trimestre de 2018, soit une détérioration de 29,7%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2018',
  link: '/documents/Bulletins/BCEM-Décembre-2018.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2018_3tri.PNG', 
  date: new Date('2018-12-17'),
  description: "Le déficit de la balance commerciale s’élève à 304,5milliards de BIF contre 289,4 milliards de BIF au même trimestre de 2017, soit une détérioration de 5,2%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2017',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-3ème-trimestre-2017_VF.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2017_3tri.PNG', 
  date: new Date('2017-11-17'),
  description: "Le déficit de la balance commerciale s’accentue de 14,3% comparativement à la même période de 2016 malgré une croissance de 19,6% enregistrée au niveau des exportations, les importations ayant connu, quant à elles, une hausse de 15,3%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du quatrième trimestre 2016',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-4ème-Trim-2016_Final-1.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2016_4tri.PNG', 
  date: new Date('2016-11-17'),
  description: "La balance commerciale affiche un déficit accru de 7,4% au quatrième trimestre 2016 comparativement au même trimestre de l’année 2015.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du deuxième trimestre 2016',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-2ème-Trim-2016.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2016_2tri.PNG',
  date: new Date('2016-08-17'),
  description: "Les échanges commerciaux s’estiment à 195,0 milliards contre 213,4 milliards le trimestre précédent et 235,9 milliards le même trimestre de 2015, soient de baisses respectives d’environ 8,6% et 17,3%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du premier trimestre 2016',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-1er-Trim-2016.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2016_1tri.PNG',
  date: new Date('2016-05-30'),
  description: "Les échanges commerciaux s’estiment à 213,4 milliards contre 288,2 milliards le trimestre précédent et 279,2 milliards le même trimestre de 2015, soient de baisses respectives d’environ 26% et 24%.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du troisième trimestre 2015',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-3ème-Trim-2015.doc.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2015_1tri.PNG',
  date: new Date('2015-11-10'),
  description: ". Le déficit commercial reste élevé et passe de 248,5 milliards au cours du quatrième trimestre 2014 à 211,4 milliards au cours du trimestre sous revue.",
},
{
  title: 'Bulletin du Commerce Exterieur de Marchandises du deuxième trimestre 2015',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-2ème-Trim-2015.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2015_2tri.PNG',
  date: new Date('2015-08-14'),
  description: "Le total des échanges au cours du deuxième trimestre 2015 connaît une diminution de 15,5% par rapport au trimestre précédant suite à la régression des importations (-17,0%) et des exportations (-4,9%) au cours de la période sous analyse.",
},
{
  title: 'Bulletin du Commerce Exterieur des marchandises du premier trimestre 2015',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-1er-Trim-2015.doc.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2015_1tri.PNG',
  date: new Date('2015-07-10'),
  description: "Le déficit commercial reste élevé et passe de 248,5 milliards au cours du quatrième trimestre 2014 à 211,4 milliards au cours du trimestre sous revue. ",
},
{
  title: 'Bulletin du Commerce Exterieur des marchandises du quatrième trimestre 2014',
  link: '/documents/Bulletins/Bulletin-Commerce-Exterieur-4ème-Trim-2014_Final.pdf',
  image: 'assets/Bulletins/bull_comm_ext_2014_4tri.PNG',
  date: new Date('2014-12-01'),
  description: "Le déficit commercial s’accentue en passant de 194,6 milliards au cours du troisième trimestre à 248,5 milliards au cours du trimestre sous analyse.",
},
];

function BulletinCommerceExterieur() {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    let filtered;
    if (year === 'Tous') {
      filtered = bulletinsData;
    } else {
      filtered = bulletinsData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
    }

  
    filtered.sort((a, b) => b.date - a.date);

    setFilteredBulletins(filtered);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  return (
    <ThemeProvider theme={createTheme()}>
      <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '50px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
            Bulletins du Commerce Extérieur de Marchandises
          </Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1" align="left" gutterBottom>
  Cette section présente les Bulletins du Commerce Extérieur de Marchandises du Burundi, avec des données et analyses clés sur les importations et les exportations.
</Typography>
          <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
              variant="outlined"
            >
              <MenuItem value="Tous">Tous les bulletins</MenuItem>
              {[...new Set(bulletinsData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index} style={{ marginBottom: '5px' }}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex' }}>
                  <CardMedia
                    component="img"
                    sx={{ width: 51, height: 80, m: 2, cursor: 'pointer' }}
                    image={bulletin.image}
                    alt={bulletin.title}
                    onClick={() => window.open(bulletin.link,  '_blank')} 
                  />
                  <CardContent style={{ flex: 1, padding: '20px' }}>
                    <Typography variant="h6" component="div" style={{ fontWeight: 'bold', color: 'green', marginBottom: '10px', cursor: 'pointer' }} onClick={() => window.open(bulletin.link, '_blank')}>
                    {<DownloadIcon />}{bulletin.title}
                    </Typography>
                    <Typography variant="body2" component="div" style={{ marginBottom: '20px' }}>
                      {bulletin.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: '#388E3C',
                color: 'white',
              }}
            >
              Plus de rapports
            </Button>
          )}
                <br />
                <br />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les bulletins du commerce extérieur de marchandises sont publiés trimestriellement, en général <strong>45 jours</strong> après la fin de chaque trimestre, ce qui correspond aux dates suivantes :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 février</strong> - Publication des données du quatrième trimestre </li>
              <li><strong>15 mai</strong> - Publication des données du premier trimestre </li>
              <li><strong>15 août</strong> - Publication des données du deuxième trimestre </li>
              <li><strong>15 novembre</strong> - Publication des données du troisième trimestre</li>
            </ul>
          </Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button 
              onClick={() => navigate('/bulletin')} 
              style={{
                marginTop: '5px',
                backgroundColor: '#388E3C', 
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des bulletins
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default BulletinCommerceExterieur;